<template>
  <div class="page">

    <transition name="fadeinplace">
      <page-body v-if="page" :title="text(page, 'page.title')" :body="html(page, 'page.body')" :footHead=" slug === 'contact' ? false : 'Contact'" :footBody="html(site, 'site.contact_details')" :showCredits="slug === 'info'" :fontStyle="fontStyle">
        <div v-if="showEnquireBtn">
          <a :href="`mailto:${email}`" target="_blank" rel="noopener">
            <enquire-btn>Enquries</enquire-btn>
          </a>
        </div>
        <subscribe-form v-if="showNewsletterForm" class="is-hidden-mobile" :mailchimpNewsletterID="mailchimpNewsletterID"></subscribe-form>
      </page-body>
    </transition>

    <article v-if="pageNotFound">
      <header><h1>Page Not Found</h1></header>
    </article>
    <appfooter :site="site"></appfooter>
  </div>
</template>

<script>
import Vue from 'vue'
import Config from 'src/config'
import Prismic from 'prismic.io'
import PageBody from 'src/components/PageBody'
import SubscribeForm from 'src/components/SubscribeForm'
import EnquireBtn from 'src/components/Button--Boxed'
import Appfooter from 'src/components/Footer'
export default {
  name: 'page',
  props: ['slug', 'site'],
  components: {
    PageBody,
    SubscribeForm,
    EnquireBtn,
    Appfooter
  },
  data () {
    return {
      page: null,
      pageNotFound: false,
      email: Config.email
    }
  },
  metaInfo () {
    return {
      meta: [
        {name: 'description', content: this.site ? this.site.getText('site.meta_description') : ''},
        {name: 'keywords', content: this.site ? this.site.getText('site.meta_keywords') : ''},
        {property: 'og:title', content: document.title ? document.title : 'Dovedale Design Studio'},
        {property: 'og:description', content: this.site ? this.site.getText('site.meta_description') : ''},
        {property: 'og:image', content: this.site ? this.site.data['site.share_image'].value.main.url : ''},
        {name: 'twitter:title', content: this.site ? this.site.getText('site.tagline') : ''},
        {name: 'twitter:title', content: document.title ? document.title : 'Dovedale Design Studio'},
        {name: 'twitter:description', content: this.site ? this.site.getText('site.meta_description') : ''},
        {name: 'twitter:image:src', content: this.site ? this.site.data['site.share_image'].value.main.url : ''},
        {itemprop: 'name', content: document.title ? document.title : 'Dovedale Design Studio'},
        {itemprop: 'description', content: this.site ? this.site.getText('site.meta_description') : ''},
        {itemprop: 'image', content: this.site ? this.site.data['site.share_image'].value.main.url : ''}
      ]
    }
  },
  computed: {
    mailchimpNewsletterID () {
      return this.site ? this.site.getText('site.mailchimp-newsletter-id') : ''
    },
    fontStyle () {
      if (!this.page) return 'serif'
      const data = this.page.data['page.font_style']
      return data ? data.value : 'serif'
    },
    showEnquireBtn () {
      return this.getPageFieldValue(this.page, 'page.show_contact_button') === 'true'
    },
    showNewsletterForm () {
      return this.getPageFieldValue(this.page, 'page.show_newsletter_form') === 'true'
    }
  },
  watch: {
    slug () {
      this.getPage()
    },
    page (page) {
      if (!page) return
      this.$nextTick(() => this.loadAtHash())
      this.setTheme()
      this.updateMeta()
    }
  },
  methods: {
    getPageFieldValue: (doc, key = 'none') => doc && doc.data && doc.data[key] && doc.data[key].value,
    html (doc, key) {
      return doc ? doc.getStructuredText(key).asHtml(Config.prismic.links) : ''
    },
    text (doc, key) {
      return doc ? doc.getText(key) : ''
    },
    loadAtHash () {
      if (this.$route.hash) {
        const el = this.$el.querySelector(this.$route.hash)
        if (el) window.scrollTo(0, el.getBoundingClientRect().top)
      }
    },
    getPage () {
      if (!this.slug) {
        this.pageNotFound = true
        return
      }
      this.page = null
      Prismic.api(Config.prismic.api_url).then((api) => {
        return api.getByUID('page', this.slug) // An empty query will return all the documents
      }).then((response) => {
        if (response) {
          this.page = response
          if (this.site) document.title = this.page.getText('page.title') + ' | ' + Config.title
        } else {
          this.pageNotFound = true
        }
      }, (err) => {
        console.log('Error getting Page: ', err)
      })
    },
    updateMeta () {
      if (!this.page) return
      Vue.updateMeta.setTitle(this.page.getText('page.title'))
      const descrip = this.page.getText('page.meta_description')
      if (descrip && descrip.length > 0) Vue.updateMeta.setDescription(descrip)
    },
    setTheme () {
      if (!this.page || !this.page.data || !this.page.data['page.theme']) return
      let theme = this.page.data['page.theme']
      theme = (theme && theme.value) ? theme.value : 'light'
      this.$emit('changeTheme', theme)
    }
  },
  created () {
    this.getPage()
  },
  mounted () {
    this.loadAtHash()
  }
}
</script>

<style lang="scss">
@import '../style/variables';

.page{
  min-height:100vh;
  background-color:inherit;
  transition:background-color $transition-fade .15s;
}
</style>



// WEBPACK FOOTER //
// Page.vue?07a445b0